export default "__VITE_ASSET__30809ba1__"